module.exports = __webpack_public_path__ + "img/urbanbohemian.216d77e1.jpg";